// AUTO-GENERATED by .githooks/pre-commit — do not edit by hand.
export const APP_VERSION = '0.22.035';
